import theme2 from './theme2';
import themedefault from './themedefault';

const themes = {
    themedefault,
    theme2
};
export default themes;



// WEBPACK FOOTER //
// ./src/config/themes/index.ts